import { createContext, useState } from "react";

export const DateContext = createContext()

export const DateContextProvider = ({children}) => {
    const [selectedDate, setSelectedDate] = useState(null)

    return (
        <DateContext.Provider
            value={{
                selectedDate,
                setSelectedDate
            }}
        >{children}</DateContext.Provider>
    )

}